var {AmpersandState, AmpersandCollection} = require('catalog/libs');
var FilterGroupCollection = require('./hpe.productlist.filtergroup.model');

/**
 * top level facet model ("filters", "category", etc)
 * model hierarchy: filterlist > facet (this) > filtergroup > filter
 */
var FacetModel = AmpersandState.extend({

    props: {
        label: 'string',
        type: 'string'
    },

    collections: {
        facets: FilterGroupCollection
    }
});

/**
 * collection of top level facet models
 */
var FacetCollection = AmpersandCollection.extend({
    model: FacetModel
});

module.exports = FacetCollection;
